import axios from 'axios'
axios.defaults.headers.common['Cache-Control'] ='no-cache';

const API_PREFIX = "/api/watchlist"
const API_PREFIX_STOCK = "/api/stock"
const API_PREFIX_FUND = "/api/fund"

export const apiCheckAssetInWatchlist = (subject_type, id) => {
    return axios.get(`${API_PREFIX}/follow/${subject_type}/${id}`)
}

export const apiWatchlist = (subject_type, action) => {
    return axios.get(`${API_PREFIX}/${action}/${subject_type}?latest_price=true`)
}

export const apiUpdateWatchlist = (subject_type, action, payload) => {
    return axios.post(`${API_PREFIX}/${action}/${subject_type}`, payload)
}

export const apiStockDaliyPerf = security_id => {
    return axios.get(`${API_PREFIX_STOCK}/public/perf/${security_id}?duration=1d`)
}

export const apiFundDaliyPerf = fund_id => {
    return axios.get(`${API_PREFIX_FUND}/nav/latest?fund=${fund_id}`)
}